<template>
  <header id='headBox'>
   <div class="site-nav">
      <div class="pageCenter navRight " >
        <div class="logoImgs" @click="onLogo" >
          <img style="display:inline-block" src="../../images/topLogo.png" alt="">
        </div>
        <div class="headNav">
          <el-menu
          :default-active="$route.path" class="el-menu-demo " mode="horizontal"  @select='handleSelect'>
          <el-menu-item index="/" :class="{'current_active':current_index==1}">首页</el-menu-item>
          <!-- <el-submenu index="/Introduction">
            <template slot="title">关于我们</template>
            <el-menu-item index="/Introduction" >公司简介</el-menu-item>
            <el-menu-item index="/companyList" >公司动态</el-menu-item>
          </el-submenu> -->
          <!-- <el-submenu index="/esay">
            <template slot="title">业务体系</template>
            <el-menu-item index="/esay">易展翅</el-menu-item>
            <el-menu-item index="/qiji">奇集</el-menu-item>
            <el-menu-item index="/myYouth" >我是青年</el-menu-item>
            <el-menu-item index="/circle">青年同心圆</el-menu-item>
          </el-submenu> -->
          <!-- <el-submenu index="/culture">
            <template slot="title">企业文化</template>
            <el-menu-item index="/culture">企业理念</el-menu-item>
            <el-menu-item index="/responsibilityList" >企业社会责任</el-menu-item>
          </el-submenu> -->
            <el-menu-item index="5" @click="goUs" > 联系我们</el-menu-item>
            <!-- <el-menu-item index="/talent" >人才招聘</el-menu-item> -->
          </el-menu>
          <!-- <div class="content">
            <span id='jian' @click='Translation_JT()'>简</span> |
            <span id= 'fan' @click='Translation_FT()'>繁</span>
          </div> -->
        </div>
      </div>
   </div>
  </header>
</template>
<script>
import ElementUI from "element-ui";
import { Translation_FT, Translation_JT } from "../../config/lange.js";
export default {
  components: {
    ElementUI
  },
  data() {
    return {
      activeIndex: "/",
      current_index: "1"
    };
  },
  // mounted() {
  //   this.Translation_JT;
  // },
  methods: {
    handleSelect(key, keyPath) {
      this.activeIndex = key;
      this.$router.push(key);
      this.current_index = 2;
      console.log(this.current_index, 9999);
    },
    Translation_FT,
    Translation_JT,
    goUs() {
      this.$router.push("/#about");
      document.querySelector("#about").scrollIntoView(true);
    },
    onLogo() {
      this.activeIndex = "";
      this.current_index = 1;
      console.log(this.$router);
      this.$router.push("/");
    }
  }
};
</script>
<style lang="scss">
.current_active {
  color: #333333 !important;
}
#headBox {
  height: 80px;
  width: 100%;
  .site-nav {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    z-index: 19;
    background-color: #fff;
    .logoImgs {
      width: 280px;
      height: 40px;
      flex-shrink: 0;
      margin-top: 20px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        line-height: 40px;
      }
    }
    .navRight {
      display: flex;
      justify-content: space-between;
    }
    .headNav {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      color: #999999;
      font-size: 14px;
      height: 80px;
      margin-right: 30px;
      .content {
        line-height: 40px;
        display: inline;
        :hover {
          color: #333333;
          cursor: pointer;
        }
      }
      .el-menu.el-menu--horizontal {
        border-bottom: #fff;
        :hover {
          color: #333333;
        }
      }
      .el-menu--horizontal > .el-menu-item.is-active {
        border-bottom: #fff;
        color: none;
      }
      .el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
      .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
        outline: 0;
        color: #333333;
      }
      .el-submenu.is-active .el-submenu__title {
        border-bottom: none;
        color: #333333;
      }
      .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
        color: none;
      }
      .el-menu-item.is-active {
        color: #999;
      }
      .el-menu--horizontal .el-menu .el-menu-item.is-active,
      .el-menu--horizontal .el-menu .el-submenu.is-active > .el-submenu__title {
        background-color: #f5f5f5;
      }
    }
  }
}
.navBar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  :hover {
    color: #651a81;
    cursor: pointer;
  }
  li {
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/headGuide.vue